import { render, staticRenderFns } from "./CardFlightInfo.vue?vue&type=template&id=37fa61a7&scoped=true&"
import script from "./CardFlightInfo.vue?vue&type=script&lang=js&"
export * from "./CardFlightInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardFlightInfo.vue?vue&type=style&index=0&id=37fa61a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa61a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VIcon,VImg})
